import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {User} from "../../../auth/models";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from "../../../main/services";
import {Contract, ContractSupplier, Tender} from "../../models";
import {VolumeBasedFee} from "../../../common/models";

@Component({
    selector: 'jft-tender-bids-table-view',
    templateUrl: './tender-bids-table-view.component.html',
    styleUrls: ['./tender-bids-table-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderBidsTableViewComponent implements OnInit {
    public tender: Tender;
    public contract: Contract;
    public offers: ContractSupplier[] = [];

    public totalFees: number = 0;

    constructor(
        public user: User,
        private route: ActivatedRoute,
        private router: Router,
        protected toast: ToastService,
    ) {
    }

    ngOnInit(): void {
        let data = this.route.snapshot.data,
            parentData = this.route.parent.snapshot.data,
            parentParentData = this.route.parent.parent.parent.snapshot.data;

        this.contract = parentData['contract'];
        this.tender = parentParentData['tender'];
        this.offers = parentData['suppliers'];
    }

    public calcTotalFees(fees: VolumeBasedFee[]){
        let val = 0;
        fees.forEach((fee, index) => {
            if (fee.price && fee.price.price){
                val += fee.price.price.value;
            }
        })
        return val;
    }

}
